export default function Description({ children, className }) {
  return <p className={` leading-[19.26px] ${className}`}>{children}</p>;
}
